export class CaldaFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getCaldas(filter) {
    return this.instance.get('/v1/recomendacoes/', {
      params: filter || null,
    });
  }

  getCalda(id, filter) {
    return this.instance.get(`/v1/recomendacoes/${id}`, {
      params: filter || null,
    });
  }

  addCalda(data) {
    return this.instance.post('/v1/recomendacoes', data);
  }

  patchCalda(id, data) {
    return this.instance.patch(`/v1/recomendacoes/${id}`, data);
  }

  editCalda(id, data) {
    return this.instance.put(`/v1/recomendacoes/${id}`, data);
  }

  getCaldaComposicao(id, filter) {
    return this.instance.get(`/v1/recomendacoes/${id}/composicoes`, {
      params: filter || null,
    });
  }

  getCaldaHistorico(id, filter) {
    return this.instance.get(`/v1/recomendacoes/${id}/utilizacao`, {
      params: filter || null,
    });
  }

  delCalda(id) {
    return this.instance.delete(`/v1/recomendacoes/${id}`);
  }

  delInsumoInCalda(idCalda, idInsumo) {
    return this.instance.delete(
      `/v1/recomendacoes/${idCalda}/composicoes/${idInsumo}`,
    );
  }

  getInsumosByCalda(id, filter) {
    return this.instance.get(`/v1/recomendacoes/${id}/composicoes`, {
      params: filter || null,
    });
  }

  duplicateCalda(data) {
    return this.instance.put('/v1/recomendacoes/duplicate', data);
  }

  getAtividadesPorPeriodo(id, params) {
    return this.instance.get(`/v1/recomendacoes/${id}/atividades-por-periodo`, {
      params: params || null,
    });
  }

  atualizarCaldaNasAtividades(id, data) {
    return this.instance.post(
      `/v1/recomendacoes/${id}/atualizar-atividades`,
      data,
    );
  }

  getUtilizacoesTalhoes(id, filter) {
    return this.instance.get(`/v1/recomendacoes/${id}/utilizacao-talhoes`, {
      params: filter || null,
    });
  }
}

export default (...params) => new CaldaFactory(...params);
